import { type BundleMachineGuard } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Whether a product is highlighted in the selection modal.
 */
export const checkIfHasPendingProduct: BundleMachineGuard = (guardArgs) => {
  const { context } = guardArgs;

  return context.pendingProduct !== undefined;
};
